import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { PRIMARY_COLOR, TERTIARY_COLOR } from "../constants/theme";
import { useNavigate } from "react-router";

const Logout = ({ openLogout, setOpenLogout }) => {
  const toggleModal = () => setOpenLogout(!openLogout);
  const navigate = useNavigate();

  return (
    <>
      {/* Modal */}
      <Modal isOpen={openLogout} toggle={toggleModal} centered size="sm">
        <ModalHeader toggle={toggleModal} className="text-center">
          <h1
            style={{
              fontSize: "26px",
              fontWeight: "600",
            }}
          >
            Logout
          </h1>
        </ModalHeader>
        <ModalBody className="text-center">
          <div
            style={{
              fontSize: "14px",
              color: "rgb(127, 132, 138)",
            }}
          >
            Are you sure you want to logout?
          </div>
        </ModalBody>
        <ModalFooter
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <Button
            color="secondary"
            onClick={toggleModal}
            style={{
              fontSize: "14px",
              border: "1.5px solid rgb(230, 230, 230)",
              color: "#000000",
              background: "none",
              fontWeight: "500",
              padding: "12px 2px",
              width: "85px",
              borderRadius: "6px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              // Add your logout logic here
              sessionStorage.clear();
              navigate("/login");
            }}
            style={{
              fontSize: "14px",
              border: `1.5px solid ${PRIMARY_COLOR}`,
              color: TERTIARY_COLOR,
              backgroundColor: PRIMARY_COLOR,
              fontWeight: "500",
              padding: "12px 2px",
              width: "85px",
              borderRadius: "6px",
            }}
          >
            Logout
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Logout;
